import IcAudio from "./ic_audio.svg";
import IcPause from "./ic_pause.svg";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { setPlayedAudio } from "../../../reducers/questionsSlice";

export const useAutoPlayAudio = ({
  content,
  audioRef,
  playingAudioRef,
  setIsAudioPlaying,
  slideId,
  explanationState,
  type, //0 content, 1 question, 2 explanation
}) => {
  const dispatch = useDispatch();
  const hasPlayedAudios = useSelector(
    (state) => state.questions.hasPlayedAudios
  );
  const currentLesson = useSelector((state) => state.questions.currentLesson);
  let isCompleted = 0;

  try {
    const sectionIdArr = [];
    const lesson = useSelector((state) => state.questions.lesson)
    lesson.sections.map((section) => {
      sectionIdArr.push(section._id)
      return 0;
    })
    currentLesson.map((progress) => {
      if(sectionIdArr.includes(progress.currentSectionId)) isCompleted = progress.isCompleted;
      return 0;
    })
  } catch (error) {}
  
  useEffect(() => {
    if (content?.audioLink && (explanationState || type !== 2) && playingAudioRef) {
      const thisAudio = audioRef.current;
      // console.log("Iscompleted: ", isCompleted)
      // console.log("content: ", content)
      // console.log("currentAudio: ", playingAudioRef.current, "playing === this: ", playingAudioRef.current === thisAudio)

      if (
        (!hasPlayedAudios[slideId + type] ||
        (playingAudioRef.current
          ? (playingAudioRef.current.currentTime < 0.2 && type !== 2)
          : false)) &&
        isCompleted === 0
      ) {
        if (playingAudioRef.current) {
          playingAudioRef.current.pause();
          playingAudioRef.current = null;
        }
        handleClickAudio(audioRef, setIsAudioPlaying);
        dispatch(setPlayedAudio({ slideId, type }));
        playingAudioRef.current = thisAudio;
      }

      const setIsAudioPlayingFalse = () => {
        setIsAudioPlaying(false);
        if (playingAudioRef.current === thisAudio) {
          playingAudioRef.current = null;
        }
      };
      const setIsAudioPlayingTrue = () => {
        setIsAudioPlaying(true);
        playingAudioRef.current = thisAudio;
      };

      thisAudio.addEventListener("pause", setIsAudioPlayingFalse);
      thisAudio.addEventListener("playing", setIsAudioPlayingTrue);

      return () => {
        thisAudio.removeEventListener("pause", setIsAudioPlayingFalse);
        thisAudio.removeEventListener("playing", setIsAudioPlayingTrue);
      };
    }
  }, [explanationState]);
};

export const handleClickAudio = (audioRef, setIsAudioPlaying) => {
  if (audioRef.current) {
    if (audioRef.current.paused) {
      audioRef.current.currentTime = 0;
      audioRef.current.muted = true;
      setTimeout(() => {
        audioRef.current.muted = false;
        audioRef.current.currentTime = 0;
      }, 400);
      audioRef.current
        .play()
        .then(() => {
          // setIsAudioPlaying(true);
        })
        .catch((e) => {
          console.log(e);
          // setIsAudioPlaying(false);
        });
    } else {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      // setIsAudioPlaying(false);
    }
  }
};

function AudioIcon({ isPlaying, onClick, style }) {
  return (
    <img
      src={isPlaying ? IcPause : IcAudio}
      onClick={onClick}
      style={{
        cursor: "pointer",
        width: "1rem",
        height: "1rem",
        marginRight: "8px",
        ...style,
      }}
      alt="Audio Icon"
    />
  );
}

export default AudioIcon;
